import { render, staticRenderFns } from "./exam-option.vue?vue&type=template&id=94042fb4&scoped=true&"
import script from "./exam-option.vue?vue&type=script&lang=js&"
export * from "./exam-option.vue?vue&type=script&lang=js&"
import style0 from "./exam-option.vue?vue&type=style&index=0&id=94042fb4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94042fb4",
  null
  
)

export default component.exports